<template>
  <div class="loading-wrapper">
    <div class="loading-content">
      <div class="loading-text">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingLayout',
  components: {
  },
  props: {
    loadingText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  destroyed() {
  },
  watch: {
  },
  mounted() {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>

.loading-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  opacity: 0.7;
  z-index: 5;

  .loading-content {
    display: flex;
    position: relative;
    left: 50%;
    top: 50%;
    z-index: 6
  }
  .fa-spin {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/layouts/LoadingLayout.vue